module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp2_6000.4b4b05df.png";